<ct-layout id="layoutDiv">
    <div>
        <router-outlet></router-outlet>
    </div>
</ct-layout>
<ct-busy *ngIf="isLoading" 
            id="isLoading" 
            [isBusy]="isLoading" 
            [backdrop]="true" 
            message="" 
            [small]="false" 
            type="center">
</ct-busy>
